module.exports = __webpack_public_path__ + "static/media/Female-Icon.2d7fa7db.svg";